import { useGetDoctorsByFilterQuery } from "graphql/generated";
import graphQLClient from "graphql/react-query";

export const useDrBio = (userIdOrEmail: string) => {
  const { data: drBySysIdRes } = useGetDoctorsByFilterQuery(
    graphQLClient,
    {
      input: {
        userSysId: userIdOrEmail
      }
    },
    {
      enabled: !userIdOrEmail.includes("@")
    }
  );

  const { data: drByEmailRes } = useGetDoctorsByFilterQuery(
    graphQLClient,
    {
      input: {
        email: userIdOrEmail
      }
    },
    {
      enabled: userIdOrEmail.includes("@")
    }
  );
  const drData =
    drBySysIdRes?.getDoctorsByFilter?.[0] || drByEmailRes?.getDoctorsByFilter?.[0] || null;

  return {
    drData
  };
};
